import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export function AskEvaButton({ question, label = "Chiedi a Eva" }) {
  const to = question ? `/eva?q=${encodeURIComponent(question)}` : "/eva";
  return (
    <Link to={to}
      className="inline-flex items-center gap-1.5 text-xs font-semibold text-green-800 bg-green-50 border border-green-200 rounded-full px-3 py-1.5 hover:bg-green-100 transition-colors"
      data-testid="ask-eva-btn">
      <Sparkles className="w-3.5 h-3.5" aria-hidden="true" />
      {label}
    </Link>
  );
}
